import { Suspense } from "react";
import { MultiOrbitSpinner3 } from "../../lib/myIcons";
import ContentLoader from "../spinner/ContentLoader";
// import ContentLoader from "../spinner/ContentLoader";

export default function LazyWrapper({ children }) {
  return (
    <Suspense
      fallback={<ContentLoader/>}
    >
      {children}
    </Suspense>
  );
}
